/** Activity sources, by the ribbon lane each draws in (section 11.0). */

import type { ActivitySource } from "../api/types";

/** One ribbon lane per source (section 11.0), network's too (ADR 0165). */
export type Lane = "phone" | "remote" | "rmm" | "email" | "network";

// `name`: what a block card calls it beside its icon (Idea #525). The remote
// lane's one source is named, as the owner calls it.
export const LANES: readonly { lane: Lane; label: string; name: string }[] = [
  { lane: "phone", label: "Phone", name: "Phone" },
  { lane: "remote", label: "Remote", name: "ScreenConnect" },
  { lane: "rmm", label: "RMM", name: "RMM" },
  { lane: "email", label: "Email", name: "Email" },
  { lane: "network", label: "Network", name: "Network" },
];

// Partial: autotask_time draws in no lane. A misspelled source doesn't
// compile (Idea #306).
const LANE_OF_SOURCE: Partial<Record<ActivitySource, Lane>> = {
  phone: "phone",
  screenconnect: "remote",
  datto_rmm: "rmm",
  email: "email",
  network: "network",
};

/** The lane an activity's source draws in, or null for one with no lane. */
export function laneOf(source: ActivitySource): Lane | null {
  return LANE_OF_SOURCE[source] ?? null;
}

export function laneLabel(lane: Lane): string {
  return LANES.find((l) => l.lane === lane)?.label ?? lane;
}

// The sources with no lane, by name (the API's SOURCE_LABELS).
const OTHER_SOURCE_LABELS: Partial<Record<ActivitySource, string>> = {
  autotask_time: "Autotask",
};

/** A source's name: its lane's, e.g. "Remote" for ScreenConnect, or its own. */
export function sourceLabel(source: ActivitySource): string {
  const lane = laneOf(source);
  return lane ? laneLabel(lane) : (OTHER_SOURCE_LABELS[source] ?? source);
}

/** A block's sources by name, as its card says them: "Phone | ScreenConnect" (Idea #525). */
export function sourceNames(lanes: readonly Lane[]): string {
  return lanes.map((lane) => LANES.find((l) => l.lane === lane)?.name ?? lane).join(" | ");
}
